import { CallbackSuccessHandler, FetchResult, useFetchCallback } from 'json-api-hooks';
import React from 'react';
import { useForm } from 'react-hook-form';

import useSnackbar from '../../../hooks/useSnackbar';
import Form from '../../Form/Form';
import { FormFieldDefinition } from '../../Form/ResourceForm';
import { InputType } from '../../Form/types';
import Heading from '../../Heading';

const fields: FormFieldDefinition[] = [
  { attribute: 'email', placeholder: 'email@voorbeeld.nl', label: 'Email', type: InputType.Email },
];

const RequestPasswordResetForm = () => {
  const methods = useForm();
  const showSnackbar = useSnackbar();
  const [callback, loading] = useFetchCallback('/u/password', 'POST');

  const handleError = ({ json }: FetchResult) =>
    methods.setError('email', {
      message: (json.errors as unknown as Record<string, string>)?.email ?? 'Er ging iets mis',
      type: 'server',
    });

  const handleSuccess: CallbackSuccessHandler = () => {
    showSnackbar('We sturen je een e-mail met instructies om je wachtwoord te resetten.');
  };

  const onSubmit = methods.handleSubmit((data) => {
    callback({ user: data }).then(handleSuccess).catch(handleError);
  });

  return (
    <>
      <Heading>Wachtwoord vergeten?</Heading>
      <Form
        description="Voer je e-mailadres in, dan sturen we je een link om je wachtwoord te resetten."
        fields={fields}
        loading={loading}
        methods={methods}
        submitLabel="Aanvragen"
        onSubmit={onSubmit}
      />
    </>
  );
};

export default RequestPasswordResetForm;
